import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  EventEmitter,
  Output,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy
} from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { ViewActions } from '../../state/view.actions';
import { ViewState } from '../../state/view.state';
import { Observable, Subject } from 'rxjs';
import {
  WhiteboardBrushSizePresets,
  WhiteboardColorPresets,
  WhiteboardEraserSizePresets,
  WhiteboardTextSizePresets,
} from 'src/app/engine/models/whiteboard-presets.const';
import { takeUntil } from 'rxjs/operators';
import { WhiteboardAnnotateMode } from '../../models/whiteboard-state.model';

@Component({
  selector: 'app-view-annotate-tools',
  templateUrl: './view-annotate-tools.component.html',
  styleUrls: ['./view-annotate-tools.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ViewAnnotateToolsComponent implements OnInit, AfterViewInit, OnDestroy {
  textSizes = WhiteboardTextSizePresets;
  brushSizes = WhiteboardBrushSizePresets;
  brushColors = WhiteboardColorPresets;
  eraserSizes = WhiteboardEraserSizePresets;
  modeEnum = WhiteboardAnnotateMode;

  @ViewChild('colorBtn', { static: true, read: ElementRef })
  colorBtn: ElementRef;


  @Select(ViewState.getWhiteboardAnnotateMode)
  mode$: Observable<WhiteboardAnnotateMode>;

  @Select(ViewState.getWhiteboardBrushSize)
  brushSize$: Observable<number>;

  @Select(ViewState.getWhiteboardTextSize)
  textSize$: Observable<number>;

  @Select(ViewState.getWhiteboardBrushColor)
  brushColor$: Observable<string>;

  @Select(ViewState.getWhiteboardEraserSize)
  eraserSize$: Observable<number>;

  @Select(ViewState.getWhiteboardHasPaint)
  hasPaint$: Observable<boolean>;

  @Select(ViewState.getWhiteboardHasText)
  hasText$: Observable<boolean>;

  @Output()
  downloadClick = new EventEmitter();

  @Output()
  clearClick = new EventEmitter();

  @Output()
  exitClick = new EventEmitter();

  private ngUnsubscribe = new Subject();
  
  constructor(private store: Store) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.brushColor$
    .pipe(
      takeUntil(this.ngUnsubscribe)
    )
      .subscribe((brushColor) => {
        this.colorBtn.nativeElement.style.setProperty('--pin-button-pin-color', brushColor);
      });

    this.hasPaint$
    .pipe(
      takeUntil(this.ngUnsubscribe)
    )
      .subscribe((hasPaint) => {
        if (!hasPaint && 
          this.store.selectSnapshot(ViewState.getWhiteboardAnnotateMode) === WhiteboardAnnotateMode.Erase
        ) {
          this.handleModeSelect(WhiteboardAnnotateMode.Paint);
        }
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  setBrushSize(size: number) {
    this.store.dispatch(new ViewActions.SetWhiteboardBrushSize(size));
  }

  setBrushColor(color: string) {
    this.store.dispatch(new ViewActions.SetWhiteboardBrushColor(color));
  }

  setTextSize(size: number) {
    this.store.dispatch(new ViewActions.SetWhiteboardTextSize(size));
  }
  
  handleModeSelect(mode: WhiteboardAnnotateMode) {
    this.store.dispatch(new ViewActions.SetWhiteboardAnnotateMode(mode));
  }

  setEraserSize(size: number) {
    this.store.dispatch(new ViewActions.SetWhiteboardEraserSize(size));
  }

  handleDownloadClick() {
    this.downloadClick.next();
  }

  handleClearClick() {
    this.clearClick.next();
  }

  handleExitClick() {
    this.exitClick.next();
  }

}
